package com.eladfinish.bible.contest.di.haptics

import com.eladfinish.bible.contest.platform.haptics.HapticService
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val hapticsCommonModule = module {
    includes(hapticsPlatformModule)
    singleOf(::HapticService)
}
